import { render } from "./Overview.vue?vue&type=template&id=2f9ec91e"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/villageOverview/Overview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f9ec91e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f9ec91e', __exports__)) {
    api.reload('2f9ec91e', __exports__)
  }
  
  module.hot.accept("./Overview.vue?vue&type=template&id=2f9ec91e", () => {
    api.rerender('2f9ec91e', render)
  })

}


export default __exports__